import { Observable } from 'rxjs';

import { BreadcrumbModel, BreadcrumbOptions } from './breadcrumb.models';
import { BreadcrumbSlot } from './breadcrumbs-slot.service';

export type BreadcrumbData = BreadcrumbModel[] | BreadcrumbSlotResolve;
export type BreadcrumbResult = BreadcrumbData | Observable<BreadcrumbData>;

export interface BreadcrumbSlotResolve extends BreadcrumbSlot {
    schemaBreadcrumbs?: BreadcrumbModel[];
}

export interface IBreadcrumbsResolve {
    resolve(model: any): BreadcrumbResult;
}

export abstract class BreadcrumbsResolve<T> implements IBreadcrumbsResolve {
    protected crumbs: BreadcrumbModel[] = [];

    resolve(model: T): BreadcrumbResult {
        this.crumbs = [];

        return this.customResolve(model);
    }

    protected abstract customResolve(model: T): BreadcrumbResult;

    protected createCrumb = (options: BreadcrumbOptions): BreadcrumbModel => {
        if (!options.sportId || !options.leagueId) {
            return {
                icon: options.icon,
                title: options.title,
                url: options.url,
                classes: options.classes,
                ignoreBrowserHistory: options.ignoreBrowserHistory,
                bgColor: options.bgColor,
                color: options.color,
            };
        }

        options.isWithRightImage = options.isWithRightImage || false;

        return {
            icon: options.icon,
            title: options.title,
            url: options.url,
            sportId: options.sportId,
            leagueId: options.leagueId,
            isWithRightImage: options.isWithRightImage,
            classes: options.classes,
            ignoreBrowserHistory: options.ignoreBrowserHistory,
            bgColor: options.bgColor,
            color: options.color,
            imageProfile: options.imageProfile,
        };
    };

    protected addToCrumbs(crumbsToAdd: BreadcrumbModel[]): BreadcrumbModel[] {
        this.crumbs.push(...crumbsToAdd);

        return this.crumbs;
    }
}
